/* =============================================================
   Noctera V2 — fiche produit (chargé en `defer`, fiches produit
   seulement, par layout/theme.liquid). Aucune dépendance.
   1. Offre Pack Duo : coloris → prix, ajout via /cart/add.js puis
      ouverture du panier (page /cart : le thème n'a pas de tiroir).
   2. Barre d'achat mobile : visible quand le bouton principal est
      sorti de l'écran par le haut ; elle déclenche CE bouton.
   3. Apparition douce des sections au défilement.
   Tout reste utilisable sans ce script : le Pack Duo est un vrai
   formulaire /cart/add, la barre collante reste simplement cachée.
   ============================================================= */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Pack Duo ---------- */

  function openCart(cartUrl) {
    // Point d'accroche si un tiroir panier est ajouté un jour au thème.
    if (window.NocteraCart && typeof window.NocteraCart.open === 'function') {
      window.NocteraCart.open();
      return;
    }
    window.location.href = cartUrl || '/cart';
  }

  function wireDuo(root) {
    var form = root.querySelector('[data-nc-duo-form]');
    if (!form || form.dataset.ncdReady === '1') return;
    form.dataset.ncdReady = '1';

    var price = root.querySelector('[data-ncd-price]');
    var cmp = root.querySelector('[data-ncd-compare]');
    var cmpValue = root.querySelector('[data-ncd-compare-value]');
    var save = root.querySelector('[data-ncd-save]');
    var saveValue = root.querySelector('[data-ncd-save-value]');
    var unit = root.querySelector('[data-ncd-unit]');
    var current = root.querySelector('[data-ncd-current]');
    var ship = root.querySelector('[data-ncd-ship]');
    var btn = root.querySelector('[data-nc-duo-submit]');
    var label = root.querySelector('[data-ncd-label]');
    var status = root.querySelector('[data-ncd-status]');
    var labelIdle = label ? label.textContent : '';

    function checked() {
      return form.querySelector('input[name="id"]:checked');
    }

    function sync() {
      var r = checked();
      if (!r) return;
      if (price) price.textContent = r.dataset.price;
      if (r.dataset.compare) {
        if (cmpValue) cmpValue.textContent = r.dataset.compare;
        if (saveValue) saveValue.textContent = r.dataset.save;
        if (cmp) cmp.hidden = false;
        if (save) save.hidden = false;
      } else {
        if (cmp) cmp.hidden = true;
        if (save) save.hidden = true;
      }
      if (unit) unit.textContent = 'soit ' + r.dataset.unit + ' le bracelet';
      if (current) current.textContent = r.dataset.title;
      // Mention « Livraison offerte en France » : seulement si CE coloris
      // atteint le seuil réglé dans les paramètres du thème.
      if (ship) ship.hidden = r.dataset.free !== '1';
    }

    function setBusy(on) {
      if (!btn) return;
      if (on) {
        btn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'Ajout en cours…';
      } else {
        btn.removeAttribute('aria-busy');
        if (label) label.textContent = labelIdle;
      }
    }

    function say(text, isError) {
      if (!status) return;
      status.classList.toggle('is-error', !!isError);
      status.textContent = text;
    }

    form.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'id') {
        say('', false);
        sync();
      }
    });

    form.addEventListener('submit', function (event) {
      // Sans fetch, le formulaire part tel quel vers /cart/add (redirection /cart).
      if (!window.fetch || !window.JSON) return;
      event.preventDefault();
      var r = checked();
      if (!r || (btn && btn.getAttribute('aria-busy') === 'true')) return;

      setBusy(true);
      say('', false);

      fetch((form.dataset.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: Number(r.value), quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function () {
          say('Pack duo ajouté au panier.', false);
          document.dispatchEvent(new CustomEvent('nc:cart-added', { detail: { variantId: Number(r.value) } }));
          openCart(form.dataset.cartUrl);
        })
        .catch(function (err) {
          setBusy(false);
          var msg = err && typeof err.description === 'string' && err.description
            ? err.description
            : 'Le pack duo n’a pas pu être ajouté. Réessayez dans un instant.';
          say(msg, true);
        });
    });

    // Retour arrière depuis /cart (cache de page) : on rend le bouton.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) setBusy(false);
      sync();
    });

    sync();
  }

  /* ---------- 2. Barre d'achat mobile ---------- */

  function wireSticky() {
    var bar = document.querySelector('[data-nc-sticky]');
    if (!bar || bar.dataset.ncReady === '1') return;
    var main = document.querySelector('[data-reveal-product]');
    var atc = main && main.querySelector('[data-pdp-atc]');
    if (!atc || !('IntersectionObserver' in window)) return;
    bar.dataset.ncReady = '1';
    document.body.classList.add('nc-has-sticky');

    var btn = bar.querySelector('[data-nc-sticky-btn]');
    var labelEl = bar.querySelector('[data-nc-sticky-label]');
    var priceEl = bar.querySelector('[data-nc-sticky-price]');
    var variantEl = bar.querySelector('[data-nc-sticky-variant]');
    var labelAdd = labelEl ? labelEl.textContent : '';
    var mq = window.matchMedia('(max-width: 749px)');
    var visible = false;

    function sync() {
      var now = main.querySelector('[data-pdp-price-now]');
      if (now && priceEl) priceEl.textContent = now.textContent.trim();
      if (variantEl) {
        var values = [];
        main.querySelectorAll('select[data-pdp-option]').forEach(function (select) { values.push(select.value); });
        if (values.length) variantEl.textContent = values.join(' / ');
      }
      if (btn) btn.disabled = atc.disabled;
      if (labelEl) labelEl.textContent = atc.disabled ? (atc.dataset.soldOutLabel || 'Indisponible') : labelAdd;
    }

    function updateLift() {
      var lift = visible && mq.matches ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--nc-fv-lift', lift + 'px');
      document.dispatchEvent(new CustomEvent('nc:sticky-change'));
    }

    function setVisible(on) {
      if (on === visible) return;
      visible = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      if (on) sync();
      updateLift();
    }

    // L'en-tête de la fiche est collant : un bouton passé dessous est déjà
    // hors de vue. La zone observée commence donc sous l'en-tête.
    var topbar = main.querySelector('.pdp__topbar');
    var headerH = topbar ? Math.round(topbar.getBoundingClientRect().height) : 0;

    new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      var limit = entry.rootBounds ? entry.rootBounds.top : headerH;
      // Visible seulement quand le bouton est passé AU-DESSUS de la zone utile.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < limit);
    }, { rootMargin: '-' + headerH + 'px 0px 0px 0px' }).observe(atc);

    if (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || atc.disabled) return;
        btn.setAttribute('aria-busy', 'true');
        atc.click();
        window.setTimeout(function () { btn.removeAttribute('aria-busy'); }, 4000);
      });
    }

    // Le moteur de variantes (noctera.js) écoute le select lui-même : notre
    // écouteur au niveau document passe après lui et lit des valeurs à jour.
    document.addEventListener('change', function (event) {
      if (main.contains(event.target)) sync();
    });

    if (mq.addEventListener) mq.addEventListener('change', updateLift);
    else if (mq.addListener) mq.addListener(updateLift);

    window.addEventListener('pageshow', function () {
      if (btn) btn.removeAttribute('aria-busy');
      sync();
    });

    sync();
  }

  /* ---------- 3. Apparition au défilement ---------- */

  function wireReveal(section) {
    if (section.dataset.ncv2Ready === '1') return;
    section.dataset.ncv2Ready = '1';
    var items = section.querySelectorAll('[data-ncv2-reveal]');
    if (!items.length || reduced || !('IntersectionObserver' in window)) return;

    // On ne cache que ce qui est encore sous l'écran : rien ne clignote.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var pending = [];
    items.forEach(function (item) {
      if (item.getBoundingClientRect().top > vh * 0.92) pending.push(item);
    });
    if (!pending.length) return;
    section.classList.add('is-js');
    items.forEach(function (item) { if (pending.indexOf(item) === -1) item.classList.add('is-in'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    pending.forEach(function (item) { io.observe(item); });
  }

  /* ---------- Initialisation ---------- */

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-nc-duo]').forEach(wireDuo);
    root.querySelectorAll('[data-ncv2]').forEach(wireReveal);
    wireSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Éditeur de thème : les sections sont réinjectées à chaque modification.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
